import * as React from 'react';
import { cn } from '@/lib/utils';

interface PageToolbarProps {
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  className?: string;
}

export function PageToolbar({ leading, trailing, className }: PageToolbarProps) {
  return (
    <div className={cn('@container/page-toolbar flex flex-col gap-3 @[860px]/page-toolbar:flex-row @[860px]/page-toolbar:items-center @[860px]/page-toolbar:justify-between', className)}>
      <div className="min-w-0 flex-1">{leading}</div>
      <div className="flex shrink-0 flex-wrap items-center gap-2">{trailing}</div>
    </div>
  );
}
